import React from 'react';
import { Truck, BadgePercent, HeartHandshake, Home, ShieldCheck, Users, Star, Leaf } from 'lucide-react';
import { services } from '../mock';
import useReveal from '../hooks/useReveal';

const brandValues = [
  { title: 'For Every Home', Icon: Home },
  { title: 'Trust & Quality', Icon: ShieldCheck },
  { title: 'People First', Icon: Users },
  { title: 'Modern & Relevant', Icon: Star },
  { title: 'Better Tomorrow', Icon: Leaf },
];

const iconMap = { Truck, BadgePercent, HeartHandshake, Sparkles: Star };

const About = () => {
  useReveal();
  return (
    <section id="about" className="py-16 lg:py-24 paper-bg">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5 reveal">
            <div className="text-[11px] uppercase tracking-[0.32em] font-semibold text-[#F58220] mb-4">
              About Us
            </div>
            <h2 className="h-display uppercase text-[40px] md:text-[60px] leading-[1.05] text-[#1a1410]">
              Modern Living. <br /><span className="text-[#F58220]">Made Simple.</span>
            </h2>
            <div className="mt-8 h-[3px] w-20 bg-[#F58220]" />
            <p className="mt-8 text-[15px] leading-[1.9] text-[#4D4D4D]">
              <span className="font-semibold text-[#1a1410]">Veetu Saama</span> is a modern home &
              appliances retail brand, making quality products for every home accessible,
              trusted and enjoyable.
            </p>
            <p className="mt-4 text-[15px] leading-[1.9] text-[#4D4D4D]">
              From kitchens to living, we bring the best brands, great service and a better
              everyday for families — featuring Dyson, Hafele, Faber, Aquaguard, LG, IFB,
              Preethi and Prestige.
            </p>

            <div className="mt-8 font-script text-[28px] text-[#F58220]">For a Better Tomorrow</div>
          </div>

          <div className="lg:col-span-7 self-start">
            {/* Brand values */}
            <div className="grid grid-cols-5 gap-3 md:gap-4 mb-8">
              {brandValues.map(({ title, Icon }, i) => (
                <div
                  key={title}
                  className="reveal flex flex-col items-center text-center gap-3"
                  style={{ transitionDelay: `${i * 80}ms` }}
                >
                  <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl flex items-center justify-center border-2 border-[#F58220] bg-white">
                    <Icon className="w-6 h-6 md:w-7 md:h-7 text-[#F58220]" strokeWidth={1.7} />
                  </div>
                  <div className="uppercase text-[10px] tracking-[0.14em] font-bold leading-[1.35] text-[#4D4D4D] max-w-[90px]">
                    {title}
                  </div>
                </div>
              ))}
            </div>
            <div className="text-center py-4 border-y border-[#E9D6C1] uppercase text-[11px] tracking-[0.32em] text-[#8E8E8E] font-semibold mb-8">
              A Complete Home Retail Destination
            </div>

            {/* Services */}
            <div className="space-y-4">
              {services.map((sv, i) => {
                const Icon = iconMap[sv.icon] || Star;
                return (
                  <div
                    key={sv.id}
                    className="reveal bg-white border border-[#E9D6C1] rounded-2xl p-6 grid grid-cols-[56px_1fr] gap-5 items-start card-lift"
                    style={{ transitionDelay: `${i * 80}ms` }}
                  >
                    <div className="w-12 h-12 rounded-xl bg-[#F58220] flex items-center justify-center">
                      <Icon className="w-5 h-5 text-white" strokeWidth={1.9} />
                    </div>
                    <div>
                      <div className="h-display uppercase text-[18px] text-[#1a1410] mb-1.5">{sv.title}</div>
                      <p className="text-[13.5px] leading-[1.7] text-[#4D4D4D]">{sv.description}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
